import type { MaybeRef } from '@vueuse/core';
import { get } from '@vueuse/core';
import type { Ref } from 'vue';
import { ref } from 'vue';
import { useBetBuilderEventExistsQuery } from '@/types';

export default function useBetBuilderMatchExists(matchId: MaybeRef<number>, isEnabled: Ref<boolean>) {
    const isBetBuilderExists = ref(false);
    const { onResult, loaded, loading } = useBetBuilderEventExistsQuery({ query: { id: get(matchId) } }, {
        enabled: isEnabled,
        pollInterval: 30000,
    });

    onResult((result) => {
        isBetBuilderExists.value = !!result;
    });

    return {
        loaded,
        loading,
        isBetBuilderExists,
    };
}
